import styled from "styled-components"
import { Icon } from "../Icon"

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 30px;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;
  width: 100%;

  color: ${(props) => props.theme.colors.gray50};
`

const Field = styled.div`
  display: flex;

  align-items: center;
  padding-left: 12px;

  border-radius: ${(props) => props.theme.sizes.defaultBorderRadius};
  background: ${(props) => props.theme.colors.gray90};
  color: ${(props) => props.theme.colors.gray60};
  height: ${(props) => props.theme.sizes.defaultInputHeight};
  border: 1px solid ${(props) => props.theme.colors.gray60};
`

interface LockedInputFieldProps {
  value: string | number
}

export const LockedInputField: React.CFC<LockedInputFieldProps> = ({
  value,
}) => {
  return (
    <Wrapper>
      <Field>{value}</Field>
      <IconWrapper>
        <Icon icon="lock-alt" size="14px" type="solid" />
      </IconWrapper>
    </Wrapper>
  )
}
